<template>
	<div class="c-app" id="app"
		v-if="!this.$apollo.loading"
		:class="'c-'+currentRoute+'-vue'"
        :data-component-name="$options.name"
	>
		<Header
			:currentDate="currentDate"
			:currentView="currentView"
			:currentSchedule="currentSchedule"
			:inboxUserProfile="inboxUserProfile"
			@set-current-view="setCurrentView($event)"
			@set-current-schedule="setCurrentSchedule($event)"
			@set-current-shift-view="shiftsView=$event"
			@set-project-filter="projectsFilter=$event"
			@change-inbox="inboxUserProfile=$event"
 			@set-current-date="setCurrentDate($event)"
 		/>
		<div class="c-app__inner">
			<LeftNav
				:isMobile="isMobile"
			/>
			<div class="c-app__view">
				<router-view
					:isMobile="isMobile"
					:currentView="currentView"
					:currentSchedule="currentSchedule"
					:shiftsView="shiftsView"
		            :currentDate="currentDate"
					:projectsFilter="projectsFilter"
            		:scrollToProject="scrollToProject"
					:inboxUserProfile="inboxUserProfile"
					@change-inbox="inboxUserProfile=$event"
					@set-current-view="setCurrentView($event)"
		            @set-current-date="setCurrentDate($event)"
					@jump-to-project-week="jumpToProjectWeek($event)"
				>
				</router-view>
			</div>
		</div>
	</div>
</template>

<script>

	window.currentDate=null;
	window.myUserProfileRole=null;
	window.myUserProfileID=null;
	window.myUserProfile=null;
	window.unreadErrorsCount=0;
	window.unreadMessagesCount=0;
	window.pendingAssignmentsCount=0;
	// window.allErrorsCount=0;
	// window.allMessagesCount=0;

	import Header from '@/components/nav/Header';
	import LeftNav from '@/components/nav/LeftNav';
    import moment from 'moment';

	import { MYPROFILE } from '@/graphql/user/queries'
    import { GENERALSETTINGS } from '@/graphql/settings/queries';
    import { INBOXDETAILS, NOTIFICATIONSCOUNT } from "@/graphql/notification/queries";

	export default {
		name: 'App',
		components: {
			Header,
			LeftNav
		},
		props: {
            date: {
                type: String,
                default: null
            },
            project: {
                type: String,
                default: null
            }
		},
		apollo: {
			myProfile: {
				query: MYPROFILE,
				fetchPolicy: 'cache-first',
				update(data) {
					window.myUserProfileRole=data.myProfile.role
					window.myUserProfileID=data.myProfile.id
					window.myUserProfile=data.myProfile
					return data
				},
				error(error) {
					if (error.message) this.$q.notify({
						type: 'negative',
						message: "Oh Oh",
						caption: error.message
					});
				},
			},
            generalSettings: {
                query: GENERALSETTINGS,
                fetchPolicy: 'cache-and-network',
                error(error){
                    if (error.message) this.$q.notify({type: 'negative', message: 'Oh Oh', caption: error.message});
                },
                update(data) {
					this.$generalSettings.settings={};
					data.generalSettings.forEach(function(setting){
						this.$generalSettings.settings[setting.key]=setting.value
					}.bind(this))

					return data.generalSettings
                },

            }
		},

		data() {
			return {
				inboxUserProfile: null,
				currentView: "weekView",
				currentSchedule: "list",
				shiftsView: "profession",
				projectsFilter: "All",
                currentDate: null,
                scrollToProject: null,
				conversationsSubscriptionTO: {},
				conversationsSubscriptions: [],
				refreshConversationsIN: {},
				isMobile: false
			};
		},
		mounted: function () {
			let currentView = this.$q.localStorage.getItem('currentView');
			if (currentView) this.currentView = currentView
			// let currentSchedule = this.$q.localStorage.getItem('currentSchedule');
			// if (currentSchedule) this.currentSchedule = currentSchedule

			if(this.project && this.date){
                this.jumpToProjectWeek({
                    projectID: this.project,
                    currentDate: this.date
                })
            }else if(this.date){
				this.setCurrentDate(this.date)
            }else{
				this.getCurrentDate();
			}

			this.$eventBus.$on('jump-to-project', function(e){
				if(e) this.jumpToProjectWeek(e);
				if(!e) this.scrollToProject=null;
            }.bind(this))

			setTimeout(function(){
				this.notificationsCount(null);
			}.bind(this), 2000)
			this.$eventBus.$on('notifications-count', function(event){
				this.notificationsCount(event.projectID);
			}.bind(this))


			this.$eventBus.$on('subscribe-to-conversation', function(event){
				if(!event.expires) event.expires=30000
				if(!this.conversationsSubscriptions.includes(event.notificationID)) this.conversationsSubscriptions.push(event.notificationID);
				if(this.conversationsSubscriptionTO[event.notificationID]) clearTimeout(this.conversationsSubscriptionTO[event.notificationID]);
				this.conversationsSubscriptionTO[event.notificationID]=setTimeout(function(){
					this.conversationsSubscriptions=this.conversationsSubscriptions.filter(item => item!=event.notificationID)
				}.bind(this), event.expires)

				this.refreshConversations();
			}.bind(this))

			window.addEventListener("resize", this.detectIfMobile);
			this.detectIfMobile();
		},
		beforeDestroy() {
            this.$eventBus.$off('jump-to-project');
            this.$eventBus.$off('notifications-count');
            this.$eventBus.$off('subscribe-to-conversation');
			window.removeEventListener("resize", this.detectIfMobile);
			clearInterval(this.refreshConversationsIN)
        },
        computed: {
            currentRoute: function(){
                if(this.$route.path.split('/')[1]=="settings") return "settings";
                return this.$route.name;
            }
        },
		watch: {
			currentRoute: function(){
				if(this.isMobile && (this.currentRoute=="projects" || this.currentRoute=="staffs")) this.$router.push("inbox")
			},
			isMobile: function(){
				if(this.isMobile && (this.currentRoute=="projects" || this.currentRoute=="staffs")) this.$router.push("inbox")
			}
		},
		methods: {
			detectIfMobile(){
				if(document.getElementById('app')){
					this.isMobile=document.getElementById('app').offsetWidth<1023
					return;
				}else{
					setTimeout(function(){
						this.detectIfMobile();
						return;
					}.bind(this), 200)
				}
			},
			refreshConversations(){
				clearInterval(this.refreshConversationsIN);
				this.refreshConversationsIN = setInterval(function(){
					if(this.conversationsSubscriptions.length==0) return;

					this.$apollo.query({
						query: INBOXDETAILS,
						fetchPolicy: 'network-only',
						variables: {
							first: 50,
							page: 0,
							id: this.conversationsSubscriptions,
							subscribe: true
						}
					})

				}.bind(this), 15000)
			},
			setCurrentView(e){
				this.currentView=e;
				this.$q.localStorage.set('currentView', this.currentView)
			},
			setCurrentSchedule(e){
				this.currentSchedule=e;
				this.$q.localStorage.set('currentSchedule', this.currentSchedule)
			},
            getCurrentDate(){
                let storedDate = this.$q.localStorage.getItem('currentDate');
                if(storedDate){
					this.currentDate=moment(storedDate).format("YYYY-MM-DD")
                }else{
					if(this.date) this.currentDate=moment(this.date).format("YYYY-MM-DD");
					if(!this.date) this.currentDate=moment().format("YYYY-MM-DD");
                }
				window.currentDate=moment(this.currentDate)
            },
			setCurrentDate(date){
                this.$q.localStorage.set('currentDate', date)
                this.scrollToProject=null
                this.currentDate=date
				window.currentDate=moment(this.currentDate)
            },
            jumpToProjectWeek(e){

				if(this.$route.name!="projects" && this.myProfile && (this.myProfile.myProfile.role=='ADMINISTRATOR' || this.myProfile.myProfile.role=='MANAGER')){
					this.$router.push("/projects")
				}
				if(this.myProfile?.myProfile.role=='STAFF'){
					this.$router.push("schedule")
				}

				this.$nextTick(function(){
					this.setCurrentDate(e.currentDate);
					this.scrollToProject=e.projectID;
					this.$eventBus.$emit('jump-to-loaded-project', e);
				}.bind(this))
            },
			notificationsCount(projectID){
				let variables={
					projectID: projectID,
					upcomingAssignmentErrors: projectID==null
				}

                this.$apollo.query({
                    query: NOTIFICATIONSCOUNT,
                    fetchPolicy: 'network-only',
                    variables: variables
                }).then(function(data){
					window.unreadErrorsCount=data.data.notificationsCount.unreadUpcomingErrors;
					window.unreadMessagesCount=data.data.notificationsCount.unreadMessages;
					window.pendingAssignmentsCount=data.data.notificationsCount.pendingAssigmnents;

					this.$eventBus.$emit('set-notifs-count', {
						projectID: projectID,
						// unreadErrorsCount: data.data.notificationsCount.unreadErrors,
						unreadErrorsCount: data.data.notificationsCount.unreadUpcomingErrors,
						unreadMessagesCount: data.data.notificationsCount.unreadMessages,
						allErrorsCount: data.data.notificationsCount.allErrors,
						allUpcomingErrorsCount: data.data.notificationsCount.allUpcomingErrors,
						allMessagesCount: data.data.notificationsCount.allMessages,
						pendingAssignmentsCount: data.data.notificationsCount.pendingAssigmnents,
						unreadProjectMessages: data.data.notificationsCount.unreadProjectMessages,
						unreadProjectErrors: data.data.notificationsCount.unreadProjectErrors,
					});
					// return data;
				}.bind(this))
			}
		}
	};
</script>

<style lang="scss">
	@import "@/scss/global.scss";
	@import "@/scss/components/app/app.scss";
</style>